module.exports = __webpack_public_path__ + "img/010-online-payment.1d4dd64b.png";